// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-module--overlay--2bVQ7","active":"modal-module--active--2fOHa","box":"modal-module--box--1hLdM","closeButton":"modal-module--closeButton--2eiTG"};